
export const groups = (state) => {
  return state.groups
}
export const dept = (state) => {
  return state.dept
}
export const total = (state) => {
  return state.total
}
export const offset = (state) => {
  return state.offset
}
export const max = (state) => {
  return state.max
}
export const getGroupById = (state) => (id) => {
  return state.groups.find(item => item.id === id)
}
export const sort = (state) => {
  return state.sort
}
export const order = (state) => {
  return state.order
}
export default {
  groups,
  dept,
  total,
  offset,
  max,
  getGroupById,
  sort,
  order
}
